import { EmitterConfigV3 } from '@pixi/particle-emitter'

export const dustParticleConfig: EmitterConfigV3 = {
	lifetime: {
		min: 0.1,
		max: 0.8,
	},
	frequency: 0.05,
	spawnChance: 1,
	particlesPerWave: 3,
	maxParticles: 20,
	emitterLifetime: 0.2,
	pos: {
		x: 0,
		y: 0,
	},
	emit: false,
	addAtBack: false,
	behaviors: [
		{
			type: 'alpha',
			config: {
				alpha: {
					list: [
						{
							value: 1,
							time: 0,
						},
						{
							value: 1,
							time: .8,
						},
						{
							value: 0,
							time: 1,
						},
					],
				},
			},
		},
		{
			type: 'scale',
			config: {
				scale: {
					list: [
						{
							value: .5,
							time: 0,
						},
						{
							value: 1,
							time: .6,
						},
						{
							value: .7,
							time: 1,
						},
					],
				},
			},
		},
		{
			type: 'color',
			config: {
				color: {
					list: [
						{
							value: 'ba9440',
							time: 0,
						},
						{
							value: '2c0c04',
							time: 0.2,
						},
						{
							value: 'd9c899',
							time: 1,
						},
					],
				},
			},
		},
		{
			type: 'moveSpeed',
			config: {
				speed: {
					list: [
						{
							value: 300,
							time: 0,
						},
						{
							value: 200,
							time: .75,
						},
						{
							value: 50,
							time: 1,
						},
					],
					isStepped: false,
				},
			},
		},
		{
			type: 'rotationStatic',
			config: {
				min: 0,
				max: -180,
			},
		},
		{
			type: 'spawnShape',
			config: {
				type: 'circle',
				data: {
					x: 0,
					y: 0,
					radius: 0,
				},
			},
		},
	],
}
